
import { Vue, Component, Prop } from "vue-property-decorator";
import { queries } from "@/apollo";
import * as legacyApollo from "@/apollo/legacySmartQuery";
import { customMoment } from "@/main";
import { User, TtPage } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { formatCount } from "@/helpers/formatCount";
import { startCase, sortBy, groupBy, uniq } from "lodash";
import TTPageDetailsModal from "../bet-details/TTPageDetailsModal.vue";
import TTDeletePageModal from "../bet-details/TTDeletePageModal.vue";
import { useTranslation } from "@/store/translation";

type ProcessedPage = {
  id: string;
  name: string;
  enteredFrom: string;
  enteredById: string;
  calculation: {
    unitCount: number;
  };
  entries: any[];
  createdAt: string;
  releaseDates: string[];
}

@Component({
  mixins: [legacyApollo.legacySmartQueries({
    user: {
      query: queries.userTtPages,
      fetchPolicy: "cache-and-network",
      skip() {
        return !this.userId || !this.value;
      },
      variables() {
        return {
          releaseDateStart: this.releaseDateStart,
          releaseDateEnd: this.releaseDateEnd,
          behalfOf: this.userId
        };
      }
    }
  })],
  components: {
    TTPageDetailsModal,
    TTDeletePageModal
  }
})
export default class TTViewBetModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ required: true }) userId!: boolean;
  user = null as null | User;

  selectedPage = null as null | ProcessedPage
  showPageDetailModal = false;
  showDeletePageModal = false;

  t = (text: string) => useTranslation().$t(text);

  releaseDateStart = customMoment()
    .startOf("day")
    .toDate();

  releaseDateEnd = customMoment()
    .add(2, "weeks")

    .startOf("day")
    .toDate();

  startCase = startCase;
  formatCount = formatCount;
  formatDollar = formatDollar;

  get processedPages(): ProcessedPage[] {


    const pages = Object.entries(groupBy(this.user?.ttPages, p => p.id)).map(([pageId, pages]) => {

      return {
        ...pages[0],
        releaseDates: uniq(pages.map(p => p.releaseDate)).sort((a, b) => customMoment(a).unix() - customMoment(b).unix()),
        calculation: pages.reduce((acc, page) => {
          return {
            unitCount: acc.unitCount + page.calculation.unit,
          };
        }, {
          unitCount: 0,
        })
      }
    })

    return sortBy(pages, p => -customMoment(p.createdAt).unix());
  }


  openPage(page: ProcessedPage) {
    this.selectedPage = page;
    this.showPageDetailModal = true;
  }


  toggleModal(val: boolean) {
    this.$emit("input", val);
  }

  handleSubmit() {
    this.toggleModal(!this.value);
  }

  formatDatetime(dateStr: string | Date) {
    return customMoment(dateStr).fromNow()
  }
  formatDate(dateStr: string | Date) {
    return customMoment(dateStr).format("DD/MM/YYYY");
  }
  formatReleaseDate(dateStr: string | Date) {
    return customMoment(dateStr).format("ddd, DD/MM/YYYY");
  }

  deletePage(pageId: string) {
    this.selectedPage = this.processedPages.find(p => p.id === pageId) || null;
    if (!this.selectedPage) {
      return;
    }
    this.showDeletePageModal = true;
  }

  reloadAll() {
    legacyApollo.refetchLegacySmartQueries(this);
  }


  handleCopy(id: TtPage["id"]) {
    const page = this.user?.ttPages.find(p => p.id === id);
    if (!page) {
      return;
    }
    this.$emit("copy", page);
    this.toggleModal(false);
    // this.selectedPage = page;
    // this.showPageDetailModal = true;
  }
}
